/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function SupportIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" {...props}>
      <path d="M7.08333 0C3.175 0 0 3.175 0 7.08333C0 10.9917 3.175 14.1667 7.08333 14.1667H7.5V16.6667C11.55 14.7167 14.1667 10.8333 14.1667 7.08333C14.1667 3.175 10.9917 0 7.08333 0ZM7.91667 12.0833H6.25V10.4167H7.91667V12.0833ZM7.91667 9.16667H6.25C6.25 6.45833 8.75 6.66667 8.75 5C8.75 4.08333 8 3.33333 7.08333 3.33333C6.16667 3.33333 5.41667 4.08333 5.41667 5H3.75C3.75 3.15833 5.24167 1.66667 7.08333 1.66667C8.925 1.66667 10.4167 3.15833 10.4167 5C10.4167 7.08333 7.91667 7.29167 7.91667 9.16667Z" />
    </SvgIcon>
  );
}
